const BASE_URL = process.env.NODE_ENV === "production" ? "https://transactions.kjdelectronics.com/v1/" : "http://localhost:2999/v1/";
export default {baseUrl: BASE_URL};